module.exports = __webpack_public_path__ + "img/webinar_graphic_mobile.c238186e.png";